import { countriesStore } from 'stores';

function formatCountry(id: number | null) {
  const model = countriesStore.findModelValue(id || 0);
  return model ? model.name() : null;
}

export { formatCountry };
